import { PropsWithChildren } from 'react'

interface CustomTableBodyProps extends PropsWithChildren {
  loading?: boolean
}

const CustomTableBody = ({ children, loading }: CustomTableBodyProps) => {
  return (
    <tbody>
      {loading ? (
        <tr className="text-center">
          <td colSpan={10}>Loading...</td>
        </tr>
      ) : (
        children
      )}
    </tbody>
  )
}

export default CustomTableBody
